let scrollViewContainer: HTMLElement | null = null; // Horizontal scroll target
let svgWrapper: HTMLElement | null = null; // Vertical scroll target

let getScrollViewRect: (() => DOMRect) | null = null;
let getSvgWrapperRect: (() => DOMRect) | null = null;

let running = false;

const SCROLL_SPEED = 10;
const EDGE_SIZE = 40; //This defines how "early" the scroll is initiate.

const mousePos = { x: 0, y: 0 };

function step() {
  if (!getScrollViewRect || !getSvgWrapperRect) return;

  const scrollViewBoundingRect = getScrollViewRect();
  const ganttChartSvgWrapper = getSvgWrapperRect();

  // Auto-scroll horizontally
  if (mousePos.x < scrollViewBoundingRect.left + EDGE_SIZE) {
    scrollViewContainer!.scrollLeft -= SCROLL_SPEED;
  } else if (mousePos.x > scrollViewBoundingRect.right - EDGE_SIZE) {
    scrollViewContainer!.scrollLeft += SCROLL_SPEED;
  }

  // Auto-scroll vertically
  if (mousePos.y < ganttChartSvgWrapper.top + EDGE_SIZE) {
    svgWrapper!.scrollTop -= SCROLL_SPEED;
  } else if (mousePos.y > ganttChartSvgWrapper.bottom - EDGE_SIZE) {
    svgWrapper!.scrollTop += SCROLL_SPEED;
  }

  if (running) requestAnimationFrame(step);
}

function trackMouse(e: MouseEvent) {
  mousePos.x = e.clientX;
  mousePos.y = e.clientY;
}

export function startAutoScroll(
  horizontalEl: HTMLElement,
  verticalEl: HTMLElement,
  getHorizontalRect: () => DOMRect,
  getVerticalRect: () => DOMRect
) {
  scrollViewContainer = horizontalEl;
  svgWrapper = verticalEl;

  getScrollViewRect = getHorizontalRect;
  getSvgWrapperRect = getVerticalRect;

  if (!running) {
    running = true;
    requestAnimationFrame(step);
    window.addEventListener("mousemove", trackMouse);
  }
}

export function stopAutoScroll() {
  running = false;
  scrollViewContainer = null;
  svgWrapper = null;
  getScrollViewRect = null;
  getSvgWrapperRect = null;
  window.removeEventListener("mousemove", trackMouse);
}
